import SectionHead from './SectionHead';
import { quickIndex } from '@/mocks/meihei';

export default function QuickIndex() {
  return (
    <section id="suolan" className="anchor-target bg-cream py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHead
            eyebrow="目录 · 直奔主题"
            title="六张卡，把吃瓜路径一次摸清"
            desc="本页按「入口 — 清单 — 脉络 — 对比 — 声量 — 手册」组织，从上往下刷，或点任意卡片直达你关心的板块。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium text-clay">
            <i className="ri-compass-3-line text-base text-ember-500" aria-hidden="true"></i>
            共 6 个内容分区
          </span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickIndex.map((item, i) => (
            <a
              key={item.num}
              href={item.href}
              className="group relative flex flex-col justify-between overflow-hidden rounded-xl border border-line bg-paper p-5 transition-all hover:-translate-y-1 hover:border-ember-200"
            >
              <div className="flex items-start justify-between">
                <span className="display text-3xl font-black text-ember-500/25 transition-colors group-hover:text-ember-500/70">
                  {item.num}
                </span>
                <span className="rounded-full bg-ember-50 px-2.5 py-1 text-[11px] font-semibold text-ember-600">
                  {item.tag}
                </span>
              </div>
              <div className="mt-5">
                <h3 className="display text-lg font-bold text-ink">{item.label}</h3>
                <p className="mt-2 min-h-[3.2rem] text-[13px] leading-relaxed text-clay">{item.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-semibold text-ember-600">
                  {i === 0 ? '进入盘点' : `查看 ${item.label}`}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}